export const getToken = () => process.env.REACT_APP_ORCH_DOCS_AUTH;
